.root {
  line-height: 1;
  padding: 10px;
}

.pageHeader{
  display: flex;
  align-items: baseline;
  justify-items: center;
  margin: 2px 0 10px 0;
}

.pageHeader > h3{
  margin-left: 10px;
}

.cbCheckbox{
  color: #25561e !important;
  float: right;
}


